/* RESPONSIBLE TEAM: team-ai-insights */
import OptimizeSuggestions from 'embercom/routes/apps/app/automation/fin-ai-agent/analyze/optimize-suggestions';

export default class FinStandaloneOptimizeSuggestions extends OptimizeSuggestions {
  analytics = {
    section: 'standalone',
    place: 'optimize-suggestions',
  };

  templateName = 'apps/app/automation/fin-ai-agent/analyze/optimize-suggestions';
  controllerName = 'apps/app/automation/fin-ai-agent/analyze/optimize-suggestions';
  routeWhenNotOptedIn = 'apps.app.standalone.setup';
}
